const Data = [
    {
        name: "Ananya Ajay Dave",
        position: "Media & Publicity Team",
        imageUrl: "/assets/images/members/Heads21/Ananya Ajay Dave.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Rajat Rathi",
        position: "Media & Publicity Team",
        imageUrl: "/assets/images/members/Heads21/Rajat Rathi.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
]

export default Data;